<template>
  <div>
    <div class="c-section">
      <h1 class="c-title2 c-title2--mb16">
        オンラインストアとの連携が完了しました
      </h1>
      <p class="p-contact__thanks">
        アプリとオンラインストアの連携が完了しました。アプリを使ってお得にお買い物を楽しみましょう。
      </p>

      <div class="p-linkOnlineStore__userInfo">
        <div class="p-linkOnlineStore__userInfo__item">
          <div class="c-title6 c-title6--mb4">氏名</div>
          <div>姓：{{ user.lastName }}</div>
          <div>名：{{ user.firstName }}</div>
        </div>
        <div class="p-linkOnlineStore__userInfo__item">
          <div class="c-title6 c-title6--mb4">オンラインストアID</div>
          <div>{{ user.id }}</div>
        </div>
      </div>

      <Button
        :href="$customUrlScheme.page('root/home/1')"
        style-type="tertiary"
        fluid
        flat
        class="p-linkOnlineStore__action">
        トップへ戻る
      </Button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  }
};
</script>
